module.exports = __webpack_public_path__ + "public/img/vipBackground.c76f3b2f.png";